import { Route } from "../$feedId"
import { FeedOverviewPage } from "./FeedOverviewPage"

export function FeedOverviewWithId() {
  const { feedId } = Route.useParams()
  return <FeedOverviewPage chatId={parseInt(feedId)} />
}
